import { DocusealForm } from "@docuseal/react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "store/store";

const DocuSeal = ({
  templateSlug,
  onComplete,
}: {
  templateSlug: string;
  onComplete: VoidFunction;
}) => {
  const navigate = useNavigate();
  const { updatedSiaApplication } = useSelector(
    (state: RootState) => state.surveyJs
  );
  return (
    <div
      style={{
        width: "100%",
        height: "calc(100% + 26px)",
        marginTop: "-30px",
        position: "relative",
      }}
    >
      {templateSlug && (
        <DocusealForm
          src={`https://docuseal.co/d/${templateSlug}`}
          email={updatedSiaApplication?.params?.contact_email}
          onComplete={() => {
            onComplete();
          }}
        />
      )}
    </div>
  );
};

export default DocuSeal;
